/*eslint-disable no-unused-vars*/
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
/*eslint-enable no-unused-vars*/
import _ from 'lodash';
import './AnimationPlayer.css';

class AnimationPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      animationReady: false,
      initiallyPlayed: false,
    }
    this.animationsRunning = 0;
  }

  componentDidMount() {
    const addAnimation = this.addAnimation.bind(this);
    const removeAnimation = this.removeAnimation.bind(this);

    _.map(this.refs, function(ref) {
      console.log(ref);
      console.log(ref.childNodes);
      ref.addEventListener('animationstart', addAnimation, false);
      ref.addEventListener('animationend', removeAnimation, false);
    });
  }

  addAnimation() {
    this.animationsRunning++;
  }

  startAnimation() {
    this.setState({
      show: true,
      animationReady: false,
    });
  }

  removeAnimation() {
    this.animationsRunning--;
    if (this.animationsRunning === 0) {
      this.setState({
        show: false,
        animationReady: true,
      });
    }
  }

  onVisibilityChange(isVisible) {
    if (isVisible && !this.state.initiallyPlayed) {
      this.startAnimation();
      this.setState({
        initiallyPlayed: true,
      });
    }
  }

  render() {
    const componentClasses = ['animation-player'];
    if (this.state.show) { componentClasses.push('show'); }
    
    return (
      <div>
        <div className={componentClasses.join(' ')}>
            {/* css fade on enter/leave */}
            <ReactCSSTransitionGroup
              transitionName="button-transition"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {this.state.animationReady &&
                <div
                  className="button-replay"
                  onClick={this.startAnimation.bind(this)}
                >
                </div>
              }
            </ReactCSSTransitionGroup>

          {/* cloning the wrapped children to turn their ids into refs */}
          {React.Children.map(this.props.children, (element, idx) => {
            return React.cloneElement(element, { ref: idx });
          })}
        </div>
        <VisibilitySensor
          onChange={this.onVisibilityChange.bind(this)}
        />
      </div>
    );
  }
};

export default AnimationPlayer;


// WEBPACK FOOTER //
// ./src/components/AnimationPlayer.js